import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoggerService } from 'src/app/common/services/logger.service';

@Component({
  selector: 'in-game-preview',
templateUrl: './in-game-preview.component.html',
  styleUrls: ['./in-game-preview.component.sass']
})
export class InGamePreviewComponent implements OnInit {
  @Input() record: any;
  @Input() field: any;
  initialBody: string = '';

  formattedBody: SafeHtml; // Use SafeHtml to store sanitized HTML

  constructor(private sanitizer: DomSanitizer, private logger: LoggerService) {}

  ngOnInit(): void {
    this.initialBody = this.record.body || '';
    this.updateFormattedBody();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes.record) {
    const previousBody = changes.record.previousValue?.body || 'No previous content';
    const currentBody = changes.record.currentValue?.body || 'No current content';

    this.logger.log('Previous Body:', previousBody);
    this.logger.log('Current Body:', currentBody);

    // Update the formatted body if the content has changed
    if (previousBody !== currentBody) {
      this.updateFormattedBody();
    }
  }
}

  

  updateFormattedBody(): void {
    const bodyContent = this.record?.body || '';
    this.formattedBody = this.insertNewlines(bodyContent);
    this.logger.log('Formatted Body:', this.formattedBody);
 }
 
  
  insertNewlines(text: string): SafeHtml {
    
    this.logger.log('text', text);

    const imageUrl = this.record?.image_ref?.thumbnail_url_1024;
    this.logger.log('imageUrl', imageUrl);

    // Use existing functions to get rewards properly
    const rewards = this.getRewardsFromRecord();
    this.logger.log('rewards found:', rewards);

    const imageTag = imageUrl
      ? `
        <div class="image-container">
          <img src="${imageUrl}" alt="Embedded Image" class="banner-image">
        </div>`
      : `
        <div class="image-container placeholder">
          <div class="placeholder-text">Please submit to see preview of banner image</div>
        </div>`;

    // Generate reward card using existing formatRewardCardItem function
    let rewardCard = '';
    if (rewards && rewards.length > 0) {
      const rewardContent = rewards.map(reward => this.formatRewardCardItem(reward)).join('');
      rewardCard = `
        <div class="reward-preview-container">
          <div class="reward-banner">
            <img src="${imageUrl || 'assets/images/default-banner.jpg'}" alt="Reward Banner" class="reward-banner-image">
          </div>
          <div class="reward-card">
            <div class="reward-title">Your Gift:</div>
            <div class="reward-card-content">
              ${rewardContent}
            </div>
          </div>
          <div class="claim-button-container">
            <button class="claim-button">Claim</button>
          </div>
        </div>`;
    }
    
    this.logger.log('rewardCard generated:', rewardCard);
  
    if (!text) {
      text = `
        <p>This is a preview of your content. Please note that the actual content will be displayed here once you submit the final version.</p>
        ${imageTag}
        <p>With love,<br>The Garden Joy Team</p>
      `;
    } else if (text.includes('{reward="Your Gift:"}')) {
      text = text.replace(/\{reward="Your Gift:"\}/g, `${rewardCard}<br>`);
    }
    else {
      // Replace {image} with the image tag and insert newlines where needed
      text = text.replace(/\{image\}/g, `${imageTag}<br>`);
  
      // Insert newline before "With love, The Garden Joy Team"
      text = text.replace(/With love,\s*The Garden Joy Team/g, '<br>With love,<br>The Garden Joy Team');
  
      // Convert any remaining newlines to <br>
      text = text.replace(/\n/g, '<br>');
    }
  
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  /**
   * Format a single reward item for display (horizontal, image on left, text on right)
   */
  private formatRewardCardItem(reward: any): string {
    if (!reward || !reward.id) {
      return '';
    }

    this.logger.log('reward', reward);

    const lineItemType = reward.lineItemType || '';
    // Use displayName for SeedPackBox, otherwise use name
    const name = lineItemType === 'SeedPackBox' 
      ? (reward.id.displayName || reward.id.name || 'Unknown Reward')
      : (reward.id.name || 'Unknown Reward');
    const amount = reward.c || '1';
    
    // Get image URL based on reward type and available image references
    let imageUrl = '';
    if (lineItemType === 'Currency' || lineItemType === 'Item') {
      if (reward.id.image_ref && reward.id.image_ref.thumbnail_url_128) {
        imageUrl = reward.id.image_ref.thumbnail_url_128;
      } else if (reward.id.image_ref && reward.id.image_ref.thumbnail_url_256) {
        imageUrl = reward.id.image_ref.thumbnail_url_256;
      } else if (reward.id.thumbnail_ref && reward.id.thumbnail_ref.thumbnails && reward.id.thumbnail_ref.thumbnails[1]) {
        imageUrl = reward.id.thumbnail_ref.thumbnails[1].path;
      }
    } else if (lineItemType === 'SeedPackBox') {
      if (reward.id.box_image_ref && reward.id.box_image_ref.thumbnail_url_128) {
        imageUrl = reward.id.box_image_ref.thumbnail_url_128;
      } else if (reward.id.box_image_ref && reward.id.box_image_ref.thumbnail_url_256) {
        imageUrl = reward.id.box_image_ref.thumbnail_url_256;
      } else if (reward.id.image_ref && reward.id.image_ref.thumbnail_url_128) {
        imageUrl = reward.id.image_ref.thumbnail_url_128;
      }
    } else if (lineItemType === 'DynamicMysteryBox') {
      if (reward.id.asset3D_ref?.thumbnails?.[0]?.path) {
        imageUrl = reward.id.asset3D_ref.thumbnails[0].path;
      } else if (reward.id.asset3D_ref?.thumbnails?.[1]?.path) {
        imageUrl = reward.id.asset3D_ref.thumbnails[1].path;
      } else if (reward.id.image_ref?.thumbnail_url_128) {
        imageUrl = reward.id.image_ref.thumbnail_url_128;
      }
    } else {
      if (reward.id.image_ref && reward.id.image_ref.thumbnail_url_128) {
        imageUrl = reward.id.image_ref.thumbnail_url_128;
      } else if (reward.id.image_ref && reward.id.image_ref.thumbnail_url_256) {
        imageUrl = reward.id.image_ref.thumbnail_url_256;
      } else if (reward.id.thumbnail_ref && reward.id.thumbnail_ref.thumbnails && reward.id.thumbnail_ref.thumbnails[1]) {
        imageUrl = reward.id.thumbnail_ref.thumbnails[1].path;
      }
    }

    // Add timestamp to prevent caching issues
    const imageTag = imageUrl 
      ? `<img src="${imageUrl}?ts=${new Date().getTime()}" alt="${name}" class="reward-preview-image-small">`
      : `<div class="reward-preview-image-small reward-card-image-placeholder">${lineItemType.charAt(0)}</div>`;

    return `
      <div class="reward-card-content-horizontal">
        <div class="reward-image-container">
          ${imageTag}
        </div>
        <div class="reward-text-container">
          <div class="reward-name"><span class="reward-amount-label">${amount}</span> ${name}</div>
        </div>
      </div>
    `;
  }

  /**
   * Extract rewards from the record object
   */
  private getRewardsFromRecord(): any[] {
    // Check various possible reward field names
    const rewardFields = ['rewards_ref', 'prizes_ref', 'rewards', 'prizes'];
    
    for (const field of rewardFields) {
      if (this.record && this.record[field] && Array.isArray(this.record[field])) {
        this.logger.log(`Found rewards in field: ${field}`, this.record[field]);
        return this.record[field];
      }
    }
    
    this.logger.log('No rewards found in record');
    return [];
  }

}
